import { Box, Grid, Typography } from "@mui/material";
import "../../../utils/styles/Politicas/14001/14001Styles.scss";
import poster1 from "../../../utils/img/Politicas/Ambiental01.jpg";
import CircleIcon from "@mui/icons-material/FiberManualRecord";

const Politica14001 = () => {
  return (
    <Box
    style={{
      position: "relative",
      marginTop: "-20px",
      zIndex: "1",
      paddingBottom: "20px",
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
    }}
  >
    <Box className="PoliticasPortada">
      <img src={poster1} alt="" />
    </Box>
    <Box style={{ padding: "82px 30px" }}>
      <Grid container>
        <Grid item xs={12} md={8}>
          <Box className="PoliticasInformacion">
            <Box textAlign="center">
              <Typography className="TittlePolitica14001">
                Política Ambiental
              </Typography>
            </Box>
            <Box>
              <Box>
                <Typography className="TextPolitica14001Part1">
                  Transmdicas es una empresa de Transporte por Carretera de Materiales Peligrosos y Carga
                  en General, presente en la Industria y Minería; consciente de nuestra responsabilidad, nos
                  comprometemos a: 
                </Typography>
              </Box>
              {/* <Box>
                <Typography className="TextPolitica14001Part2">
                  Siendo conscientes de nuestra responsabilidad, nos
                  comprometemos a:
                </Typography>
              </Box> */}
              <Box style={{ marginBottom: "20px" }}>
                <Box display="flex">
                  <Box>
                    <CircleIcon
                      style={{ fontSize: "small", marginRight: "10px" }}
                    />
                  </Box>
                  <Typography className="TextPolitica14001Part3">
                    Establecer objetivos y metas ambientales coherentes con esta política y que se
                    encuentren alineados con el contexto de la organización, asegurando su
                    seguimiento, evaluación periódica y cumplimiento.
                  </Typography>
                </Box>
                <Box display="flex">
                  <Box>
                    <CircleIcon
                      style={{ fontSize: "small", marginRight: "10px" }}
                    />
                  </Box>
                  <Typography className="TextPolitica14001">
                    Fomentar una cultura ambiental que involucre a todo el personal y permita
                    comprender la importancia de la protección del medio ambiente.
                  </Typography>
                </Box>
                <Box display="flex">
                  <Box>
                    <CircleIcon
                      style={{ fontSize: "small", marginRight: "10px" }}
                    />
                  </Box>
                  <Typography className="TextPolitica14001">
                    Identificar, evaluar y controlar nuestros aspectos ambientales significativos,
                    considerando un enfoque de ciclo de vida en la planificación y ejecución de
                    nuestras actividades
                  </Typography>
                </Box>
                <Box display="flex">
                  <Box>
                    <CircleIcon
                      style={{ fontSize: "small", marginRight: "10px" }}
                    />
                  </Box>
                  <Typography className="TextPolitica14001">
                    Cumplir con la legislación ambiental aplicable, así como con otros requisitos
                    suscritos por la organización relacionados con nuestros aspectos ambientales.
                  </Typography>
                </Box>
                <Box display="flex">
                  <Box>
                    <CircleIcon
                      style={{ fontSize: "small", marginRight: "10px" }}
                    />
                  </Box>
                  <Typography className="TextPolitica14001">
                    Promover la mejora continua de nuestro Sistema de Gestión Ambiental,
                    permitiendo mejorar nuestro desempeño y reducir los impactos ambientales
                    negativos.
                  </Typography>
                </Box>
              </Box>
              
              <Box className="positiconversionandfecha">
                <Typography>V.04</Typography>
                <Typography>02/01/2026</Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  </Box>
  );
};

export default Politica14001;
